<template>
  <div>
    <v-navigation-drawer
      app
      class="dont-print-header ht-sidebar"
      :class="{ 'ht-sidebar--mini': mini && !$vuetify.breakpoint.mobile }"
      :mini-variant="mini && !$vuetify.breakpoint.mobile"
      :width="240"
      mini-variant-width="68"
      v-model="drawer"
    >
      <v-list>
        <div class="ht-sidebar__brand">
          <v-img
            alt="Healthy Tantra"
            contain
            :src="require('../../assets/healthy-tantra-logo.png')"
            :max-width="mini && !$vuetify.breakpoint.mobile ? 44 : 120"
            :height="mini && !$vuetify.breakpoint.mobile ? 44 : 120"
          />
        </div>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{
                  user.first_name != null
                    ? user.first_name + " " + user.last_name
                    : user.email
                }}
              </v-list-item-title>
              <v-list-item-subtitle>{{
                roleName == "SUPER ADMIN" && company.id != null
                  ? "ADMIN"
                  : roleName
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <v-list-item
            v-if="
              roleName == 'ADMIN' ||
              (roleName == 'SUPER ADMIN' && company.id != null)
            "
            :to="`/companies/${encryptIt(this.company.id)}`"
          >
            <v-list-item-title>Company</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item to="/notifications" @click="hide_bell = true">
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item> -->
        </v-list-group>
      </v-list>
      <v-divider></v-divider>
      <v-list nav dense>
        <!-- <v-list-item
          :to="`/companies`"
          v-if="can('COMPANIES.VIEW')"
        >
          <v-list-item-icon>
            <v-icon>mdi-office-building-marker-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Companies</v-list-item-title>
        </v-list-item> -->

        <!-- Admin List — Super Admin only, shown at top -->
        <v-list-item
          to="/admins"
          v-if="isSuperAdmin && !isGuestUser"
        >
          <v-list-item-icon>
            <v-icon>mdi-shield-crown-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Admin List</v-list-item-title>
        </v-list-item>

        <!-- Admin Dashboard -->
        <v-list-item to="/home" v-if="(isAdmin || isSuperAdmin) && !isGuestUser">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>

        <!-- Doctors Menu -->
        <v-list-item to="/doctors" v-if="canView('users') && !isGuestUser">
          <v-list-item-icon>
            <v-icon>mdi-doctor</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Doctors</v-list-item-title>
        </v-list-item>

        <!-- Patients Menu -->
        <v-list-item to="/patients" v-if="canView('users') && !isGuestUser">
          <v-list-item-icon>
            <v-icon>mdi-account-injury-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Patients</v-list-item-title>
        </v-list-item>

        <!-- Customers Menu -->
        <v-list-item to="/customers" v-if="canView('users') && !isGuestUser">
          <v-list-item-icon>
            <v-icon>mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Customers</v-list-item-title>
        </v-list-item>

        <!-- Sellers Menu (for admins) -->
        <v-list-group
          no-action
          :value="false"
          v-if="canView('users') && !isGuestUser"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-storefront-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Sellers</v-list-item-title
            >
          </template>
          <v-list-item :to="`/sellers`">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/seller-products`">
            <v-list-item-icon>
              <v-icon>mdi-account-arrow-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Seller Products</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Seller Dashboard (for sellers only) -->
        <v-list-item
          to="/seller-home"
          v-if="positionName == 'SELLER'"
        >
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>

        <v-list-item
          :to="`/seller-products`"
          v-if="positionName == 'SELLER'"
        >
          <v-list-item-icon>
            <v-icon>mdi-store</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Seller Products</v-list-item-title>
        </v-list-item>

        <v-list-item
          :to="`/orders`"
          v-if="positionName == 'SELLER'"
        >
          <v-list-item-icon>
            <v-icon>mdi-cart</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Orders</v-list-item-title>
        </v-list-item>

        <v-list-item
          :to="`/payouts`"
          v-if="positionName == 'SELLER'"
        >
          <v-list-item-icon>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Payouts</v-list-item-title>
        </v-list-item>

        <v-list-item
          :to="`/profile/${encryptIt(user.id)}`"
          v-if="positionName == 'SELLER'"
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>My Profile</v-list-item-title>
        </v-list-item>

        <!-- Penalties Menu -->
        <!-- <v-list-group
          no-action
          :value="false"
          v-if="canView('penalties') && !isGuestUser"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-gavel</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Penalties</v-list-item-title
            >
          </template>
          <v-list-item :to="`/penalties`">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group> -->

        <v-list-group
          no-action
          :value="false"
          v-if="canView('products') && !isGuestUser && positionName != 'SELLER'"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-cube-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Products</v-list-item-title
            >
          </template>
          <v-list-item :to="`/products`">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/seller-product-variants/upload`" v-if="positionName != 'SELLER'">
            <v-list-item-icon>
              <v-icon>mdi-cloud-upload</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Bulk Upload</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/products/upload-history`" v-if="positionName != 'SELLER'">
            <v-list-item-icon>
              <v-icon>mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Upload History</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Consultations — direct link for Admin/Super Admin -->
        <v-list-item to="/consultations" v-if="(isAdmin || isSuperAdmin) && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-stethoscope</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Consultations</v-list-item-title>
        </v-list-item>

        <v-list-item to="/prescriptions" v-if="(isAdmin || isSuperAdmin) && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-prescription</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Prescriptions</v-list-item-title>
        </v-list-item>

        <v-list-item to="/appointments" v-if="canView('appointments') && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Appointments</v-list-item-title>
        </v-list-item>

        <v-list-item to="/orders" v-if="canView('orders') && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-clipboard-list-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Orders</v-list-item-title>
        </v-list-item>

        <!-- Payouts Menu -->
        <v-list-item to="/payouts" v-if="(isAdmin || isSuperAdmin) && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-bank-transfer-out</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Payouts</v-list-item-title>
        </v-list-item>

        <!-- Transactions — direct link for Admin/Super Admin -->
        <v-list-item to="/transactions" v-if="(isAdmin || isSuperAdmin) && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-swap-horizontal-bold</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Transactions</v-list-item-title>
        </v-list-item>

        <!-- Transaction Audit Report — Admin/Super Admin only -->
        <v-list-item to="/reports/transaction-audit" v-if="(isAdmin || isSuperAdmin) && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Audit Report</v-list-item-title>
        </v-list-item>

        <v-list-item to="/categories" v-if="canView('categories') && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-shape-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Categories</v-list-item-title>
        </v-list-item>

        <v-list-item to="/tags" v-if="canView('tags') && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-tag-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Tags</v-list-item-title>
        </v-list-item>

        <v-list-item to="/coupons" v-if="canView('coupons') && !isGuestUser && positionName != 'SELLER'">
          <v-list-item-icon>
            <v-icon>mdi-ticket-percent-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Coupons</v-list-item-title>
        </v-list-item>

        <v-list-group
          no-action
          :value="false"
          v-if="
            positionName != 'SELLER' &&
            (roleName == 'ADMIN' ||
              (roleName == 'SUPER ADMIN' && company.id != null))
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-truck-delivery</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Delivery Partners</v-list-item-title
            >
          </template>
          <v-list-item :to="`/delivery-partners`">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/deliveries`">
            <v-list-item-icon>
              <v-icon>mdi-truck-fast</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Deliveries</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item
          to="/chat-messages"
          v-if="(roleName == 'ADMIN' || (roleName == 'SUPER ADMIN' && company.id != null)) && positionName != 'SELLER'"
        >
          <v-list-item-icon>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Chats</v-list-item-title>
        </v-list-item>

        <v-list-item to="/announcements" v-if="canView('announcements') && !isGuestUser">
          <v-list-item-icon>
            <v-icon>mdi-bullhorn-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Announcements</v-list-item-title>
        </v-list-item>

        <v-list-item to="/daily-tips" v-if="canView('daily_tips') && !isGuestUser">
          <v-list-item-icon>
            <v-icon>mdi-lightbulb-on-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Tip of the Day</v-list-item-title>
        </v-list-item>

        <v-list-item to="/raise-tickets" v-if="canView('raise_tickets') && !isGuestUser">
          <v-list-item-icon>
            <v-icon>mdi-lifebuoy</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Help &amp; Support</v-list-item-title>
        </v-list-item>

        <!-- Approvals Menu -->
        <v-list-group
          no-action
          :value="false"
          v-if="(isAdmin || isSuperAdmin) && !isGuestUser"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-clipboard-check-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Approvals</v-list-item-title
            >
          </template>

          <v-list-item :to="`/education_details/approvals`">
            <v-list-item-icon>
              <v-icon>mdi-school</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Education Approvals</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/products/approvals`">
            <v-list-item-icon>
              <v-icon>mdi-package-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Product Approvals</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/bank-details/approvals`">
            <v-list-item-icon>
              <v-icon>mdi-bank</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Bank Details Approvals</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/council_registration_certificates/approval`">
            <v-list-item-icon>
              <v-icon>mdi-certificate</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Council Certificate Approvals</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Doctor Tools Menu (for doctors only) -->
        <v-list-group
          no-action
          :value="false"
          v-if="hasRole('DOCTOR') && canAccessHealthcare()"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-doctor</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Doctor Tools</v-list-item-title
            >
          </template>

          <v-list-item :to="`/consultations`">
            <v-list-item-icon>
              <v-icon>mdi-stethoscope</v-icon>
            </v-list-item-icon>
            <v-list-item-title>My Consultations</v-list-item-title>
          </v-list-item>


          <v-list-item :to="`/chat`">
            <v-list-item-icon>
              <v-icon>mdi-message</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Chat</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/prescriptions`">
            <v-list-item-icon>
              <v-icon>mdi-prescription</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Prescriptions</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/profile/${encryptIt(user.id)}`">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Quick Access Menu -->
        <v-list-group
          no-action
          :value="false"
          v-if="(isAdmin || isSuperAdmin) && !isGuestUser"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-rocket-launch-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Quick Access</v-list-item-title
            >
          </template>

          <v-list-item :to="`/work_histories`">
            <v-list-item-icon>
              <v-icon>mdi-briefcase</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Work Histories</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/awards`">
            <v-list-item-icon>
              <v-icon>mdi-trophy</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Awards</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/memberships`">
            <v-list-item-icon>
              <v-icon>mdi-card-account-details</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Memberships</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          no-action
          :value="false"
          v-if="(isAdmin || isSuperAdmin) && !isGuestUser"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Settings</v-list-item-title
            >
          </template>

          <v-list-item :to="`/values`">
            <v-list-item-icon>
              <v-icon>mdi-database-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Value</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/positions`">
            <v-list-item-icon>
              <v-icon>mdi-account-badge-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Position</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/languages`">
            <v-list-item-icon>
              <v-icon>mdi-translate</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Languages</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/profile/${encryptIt(user.id)}`">
            <v-list-item-icon>
              <v-icon>mdi-account-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!--
          Developer Tools — gated on isSuperAdmin rather than a permission,
          because can()/meta.permission both return true for any plain ADMIN.
          These open pages served by the Laravel API, not SPA routes.
        -->
        <v-list-group no-action :value="false" v-if="isSuperAdmin && !isGuestUser">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-wrench-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              >Developer Tools</v-list-item-title
            >
          </template>

          <v-list-item @click="openApiConsole">
            <v-list-item-icon>
              <v-icon>mdi-api</v-icon>
            </v-list-item-icon>
            <v-list-item-title>API Console</v-list-item-title>
          </v-list-item>
          <v-list-item @click="openDevTool('/quick-links')">
            <v-list-item-icon>
              <v-icon>mdi-link-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Quick Links</v-list-item-title>
          </v-list-item>
          <v-list-item @click="openDevTool('/reverb-dashboard')">
            <v-list-item-icon>
              <v-icon>mdi-broadcast</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Reverb Dashboard</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          no-action
          :value="false"
          v-if="(isAdmin || isSuperAdmin) && !isGuestUser"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Trash</v-list-item-title>
          </template>

          <v-list-item :to="`/doctors?open_trash=true`" v-if="canView('users')">
            <v-list-item-icon>
              <v-icon>mdi-doctor</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Doctors</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="`/patients?open_trash=true`"
            v-if="canView('users')"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-heart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Patients</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/sellers?open_trash=true`" v-if="canView('users')">
            <v-list-item-icon>
              <v-icon>mdi-store</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sellers</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="`/penalties?open_trash=true`"
            v-if="canView('penalties')"
          >
            <v-list-item-icon>
              <v-icon>mdi-gavel</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Penalties</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="`/products?open_trash=true`"
            v-if="canView('products')"
          >
            <v-list-item-icon>
              <v-icon>mdi-package-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Products</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/tags?open_trash=true`" v-if="canView('tags')">
            <v-list-item-icon>
              <v-icon>mdi-tag</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Tags</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/consultations?open_trash=true`">
            <v-list-item-icon>
              <v-icon>mdi-stethoscope</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Consultations</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/prescriptions?open_trash=true`">
            <v-list-item-icon>
              <v-icon>mdi-prescription</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Prescriptions</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/prescription-items?open_trash=true`">
            <v-list-item-icon>
              <v-icon>mdi-pill</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Prescription Items</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/chats?open_trash=true`">
            <v-list-item-icon>
              <v-icon>mdi-message</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Chats</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/chat-messages?open_trash=true`">
            <v-list-item-icon>
              <v-icon>mdi-message-text</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Chat Messages</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/transactions?open_trash=true`">
            <v-list-item-icon>
              <v-icon>mdi-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Transactions</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/bank-details?open_trash=true`">
            <v-list-item-icon>
              <v-icon>mdi-bank</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Bank Details</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="`/council_registration_certificates?open_trash=true`"
          >
            <v-list-item-icon>
              <v-icon>mdi-certificate</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Council Certificates</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/work_histories?open_trash=true`">
            <v-list-item-icon>
              <v-icon>mdi-briefcase</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Work Histories</v-list-item-title>
          </v-list-item>
          <v-list-group
            no-action
            sub-group
            :value="false"
            v-if="
              roleName == 'ADMIN' ||
              (roleName == 'SUPER ADMIN' && company.id != null)
            "
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Settings</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item :to="`/positions?open_trash=true`" link>
              <v-list-item-icon>
                <v-icon>mdi-account-badge-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Position</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="white"
      flat
      class="dont-print-header ht-appbar"
    >
      <v-app-bar-nav-icon
        variant="text"
        @click.stop="toggleSidebar"
        aria-label="Toggle navigation"
      ></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            alt="Vuetify Name"
            class="mt-1"
            contain
            min-width="50"
            :src="require('../../assets/healthy-tantra-logo.png')"
            width="50"
            height="50"
        /></router-link>
      </div>
      &nbsp;
      <span class="my-auto ht-appbar__title">
        Hey,
        {{ user.user_name != null ? user.user_name : user.email }}
      </span>
      <v-container class="mt-5 ml-4 ml-md-8" fluid v-if="roleName == 'SUPER ADMIN'">
        <v-switch
          inset
          @change="switch_to(company.id)"
          :loading="isSwitching"
          v-model="is_acting_admin"
          :label="`${is_acting_admin ? 'ADMIN' : 'SUPERADMIN'}`"
        ></v-switch>
      </v-container>
      <v-spacer></v-spacer>

      <div class="ht-appbar__user d-none d-sm-flex">
        <span class="ht-appbar__user-name">{{
          user.first_name != null
            ? user.first_name + " " + user.last_name
            : user.email
        }}</span>
        <span class="ht-appbar__user-role">{{
          roleName == "SUPER ADMIN" && company.id != null ? "ADMIN" : roleName
        }}</span>
      </div>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div v-if="hide_bell == false">
            <!-- <v-badge overlap color="pink" icon="mdi-bell"> -->
            <v-avatar color="primary" size="38" class="ht-avatar" v-bind="attrs" v-on="on">
              <v-icon dark> mdi-account-circle </v-icon>
            </v-avatar>
            <!-- </v-badge> -->
          </div>
          <div v-else>
            <v-avatar color="primary" size="38" class="ht-avatar" v-bind="attrs" v-on="on">
              <v-icon dark> mdi-account-circle </v-icon>
            </v-avatar>
          </div>
        </template>
        <v-list dense>
          <!-- <v-list-item to="/notifications" @click="hide_bell = true">
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item> -->
          <v-list-item
            :to="`/profile/${encryptIt(user.id)}`"
            @click="hide_bell = true"
          >
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <router-view />
    <!-- Clear Success Dialog Box -->
    <v-dialog v-model="show_company_dialog" width="850">
      <v-card rounded="xxl">
        <v-card-title> <h1>Switch to Admin</h1> </v-card-title>
        <v-card-subtitle class="my-1">
          Please select the company whose admin portal you'd like to switch to.
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col md="6">
              <v-text-field
                solo
                rounded
                v-model="form.search_keyword"
                label="Search ... "
                clearable
                color="#e60040"
                @click:clear="(form.search_keyword = null), getCompanies()"
                prepend-inner-icon="mdi-magnify"
                @keydown.enter="getCompanies"
                @change="page = 1"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-linear>
          <v-row v-else>
            <v-col md="12">
              <v-simple-table fixed-header height="285" class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Admin Name</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="companies.length != 0">
                    <tr
                      v-for="(company, i) in companies"
                      :key="`company_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': companies.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="company.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Company is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="company.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Company is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-avatar rounded>
                          <v-img
                            alt="Vuetify Name"
                            class="mt-1"
                            contain
                            min-width="35"
                            :src="
                              company.logo_path
                                ? `${mediaUrl + company.logo_path}`
                                : require('../../assets/healthy-tantra-logo.png')
                            "
                            width="35"
                            height="35"
                          />
                        </v-avatar>
                        &nbsp;
                        {{ company.name || "" }}
                      </td>
                      <td>{{ company.email || "" }}</td>
                      <td>{{ company.admin_name || "" }}</td>
                      <td class="text-right">
                        <v-btn
                          class="ml-2"
                          fab
                          x-small
                          color="primary"
                          @click="changeCompany(company.id)"
                        >
                          <v-icon dark> mdi-account-switch-outline </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import { mapActions } from "vuex";
import axios from "@/axios";
import store from "@/store";

export default {
  data() {
    return {
      form: {
        search_keyword: "",
      },
      hide_bell: false,
      drawer: true,
      mini: false,
      is_acting_admin: false,
      companyName: "",
      selectedCompanyId: "",
      company_data: {},
      companies: [],
      is_company_user: false,
      isLoading: false,
      isSwitching: false,
      show_company_dialog: false,
    };
  },
  mounted() {
    try {
      this.mini = localStorage.getItem("ht_sidebar_mini") === "1";
    } catch (e) {
      this.mini = false;
    }
    let company = store.getters["auth/company"];
    if (Object.keys(company).length > 0) {
      this.selectedCompanyId = company.id;
      if (this.roleName == "SUPER ADMIN") {
        this.is_acting_admin = true;
        console.log(this.is_acting_admin);
      }
      this.is_company_user = company ? true : false;
    }
  },
  computed: {
    positionName() {
      console.log("positionName ==>", this.user);
      return this.user && this.user.position && this.user.position.name
        ? this.user.position.name.toUpperCase()
        : "";
    },
  },
  methods: {
    // UI only: collapse to icon rail on desktop, open/close the drawer on mobile
    toggleSidebar() {
      if (this.$vuetify.breakpoint.mobile) {
        this.drawer = !this.drawer;
        return;
      }
      this.mini = !this.mini;
      try {
        localStorage.setItem("ht_sidebar_mini", this.mini ? "1" : "0");
      } catch (e) {
        /* storage unavailable — keep in-memory state */
      }
    },
    ...mapActions({
      logOut: "auth/logOut",
    }),
    logout() {
      this.logOut();
      location.replace("/");
    },
    isActingAdmin() {
      let response = false;
      if (this.roleName == "SUPER ADMIN" && this.company.id != null) {
        response = true;
      }
      return response;
    },
    // Developer tools are Blade pages served by the API, not SPA routes, so we
    // derive their origin by stripping the trailing /api from the axios baseURL.
    apiOrigin() {
      return String(this.baseUrl || "").replace(/\/api\/?$/, "");
    },
    openDevTool(path) {
      window.open(this.apiOrigin() + path, "_blank", "noopener");
    },
    // The token travels in the URL *fragment*: fragments are never sent to the
    // server, so it stays out of access logs and the Referer header. The console
    // reads it on load and immediately clears the hash.
    openApiConsole() {
      const params = new URLSearchParams();
      const token = localStorage.getItem("token");
      if (token) params.set("token", token);
      if (this.company && this.company.id) params.set("company", this.company.id);
      params.set("target", this.apiOrigin());
      window.open(
        this.apiOrigin() + "/api-console#" + params.toString(),
        "_blank",
        "noopener"
      );
    },
    // Scroll back to the 1st validation error Message
    scrollToSection(selector) {
      // Example: smooth scroll to the specific section
      const element = document.querySelector(selector);
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - window.innerHeight / 2;
      window.scrollTo({
        top: middle,
        behavior: "smooth",
      });
      console.log(selector);
    },
    async getCompanies() {
      this.isLoading = true;
      this.form.search_keyword = this.form.search_keyword
        ? this.form.search_keyword
        : "";
      this.form.is_active = this.form.is_active ? this.form.is_active : "";
      let companies = [];
      let query =
        "search_keyword=" +
        this.form.search_keyword +
        "&is_active=" +
        this.form.is_active;
      companies = await axios.get(`companies?${query}`);
      this.companies = companies.data.data;
      this.count = companies.data.count;
      this.isLoading = false;
    },
    changeCompany(companyId) {
      this.selectedCompanyId = companyId;
      let company = this.companies.find((s) => s.id == this.selectedCompanyId);
      if (company) {
        console.log(company);
        store.dispatch("auth/setCompany", company);
        this.is_company_user = true;
      } else {
        store.dispatch("auth/setCompany", "");
        this.is_company_user = false;
      }
      window.location.href = "/auth/login";
      this.isSwitching = false;
      this.show_company_dialog = false;
      // this.$router.push("/auth/login");
    },
    switch_to() {
      this.isSwitching = true;
      if (this.is_acting_admin == true) {
        this.show_company_dialog = true;
        this.getCompanies();
      } else {
        this.selectedCompanyId = null;
        this.changeCompany();
      }
    },
  },
};
</script>
<style scoped>
.nav-text {
  text-decoration: none;
  color: black;
  font-weight: bold;
  font-size: 20px;
}

.ht-avatar {
  cursor: pointer;
  transition: box-shadow 180ms ease;
}

.ht-avatar:hover {
  box-shadow: 0 0 0 3px rgba(77, 112, 130, 0.2);
}

.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding: 0 8px 0 20px;
}
</style>
